import * as React from 'react';
import {
  Modal,
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Button,
  IconButton,
  Divider
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

// Define the style for the modal content (the 'Box' inside the 'Modal')
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400, // You can adjust the width as needed
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  maxHeight: '80vh', // Limit the height
  overflowY: 'auto', // Allow scrolling for long lists
};



const InterestedCandidates = ({trainingName, list, open, setOpen}) => {
  const handleClose = () => setOpen(false);

const handleDownload = () => {

  // CSV header
  const header = `${trainingName}\n`;

  // Convert array to CSV string
  const csvContent = header + list.join("\n");

  // Create a Blob from the CSV content
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

  // Create a temporary download link
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `${trainingName}-InterestedCandidates.csv`);

  // Append to the DOM and trigger download
  document.body.appendChild(link);
  link.click();

  // Cleanup
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};


  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="interested-candidates-modal-title"
        aria-describedby="interested-candidates-modal-description"
      >
        <Box sx={style}>
          {/* Header with Title and Close button */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 2,
            }}
          >
            <Typography
              id="interested-candidates-modal-title"
              variant="h6"
              component="h2"
            >
              Interested Candidates
            </Typography>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              size="small"
            >
              <CloseIcon />
            </IconButton>
          </Box>

          <Divider sx={{ mb: 2 }} />

          {/* List of Candidates */}
          <List id="interested-candidates-modal-description">
            {list?.length > 0 ? (
              list.map((candidate,idx) => (
                <ListItem key={idx}>
                  {candidate}
                </ListItem>
              ))
            ) : (
              <Typography variant="body1" color="text.secondary">
                No candidates have shown interest yet.
              </Typography>
            )}
          </List>

          <Button
            disabled={!list|| list.length==0}
            onClick={handleDownload}
            fullWidth
            variant="outlined"
            sx={{ mt: 3 }}
          >
            Download List
          </Button>
        </Box>
      </Modal>
    </>
  );
};

export default InterestedCandidates;